import React, { useEffect } from 'react';

function FullscreenImageModal({ isOpen, imageUrl, cardName, onClose }) {
  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape') {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener('keydown', handleEscape);
      document.body.style.overflow = 'hidden';
    }

    return () => {
      document.removeEventListener('keydown', handleEscape);
      document.body.style.overflow = 'unset';
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className="card-modal" onClick={handleBackdropClick}>
      <div className="card-modal-content">
        <button className="card-modal-close" onClick={onClose}>
          ✕
        </button>
        <img 
          src={imageUrl} 
          alt={cardName}
          onError={(e) => {
            e.target.style.display = 'none';
          }}
        />
      </div>
    </div>
  );
}

export default FullscreenImageModal;